import React from 'react';
import { FaUserCircle, FaUser, FaUserTie, FaEnvelope, FaPhone, FaLinkedin } from 'react-icons/fa';
import './styles/grundlæggendeInfo.css';

const GrundlæggendeInfo = ({ formData, handleChange, users }) => {
  return (
    <div className="form-section basic-info-section">
      <div className="section-header">
        <div className="header-title">
          <FaUserCircle className="section-icon" />
          <div>
            <h3>Grundlæggende information</h3>
            <div className="section-description">
              Kontaktinformation og primære detaljer
            </div>
          </div>
        </div>
      </div>
      
      <div className="form-grid two-columns">
        <div className="crm-basic__group">
          <label className="crm-basic__label">
            <FaUser className="crm-basic__label-icon" />
            Account Owner
          </label>
          <div className="crm-basic__input-wrapper">
            <select
              name="accountOwner"
              value={formData.accountOwner || ''}
              onChange={handleChange}
              className="crm-basic__select"
            >
              <option value="">Vælg account owner</option>
              {users.map(user => (
                <option key={user.id} value={user.id}>
                  {user.name || user.email}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="crm-basic__group">
          <label className="crm-basic__label">
            <FaEnvelope className="crm-basic__label-icon" />
            Email
          </label>
          <div className="crm-basic__input-wrapper">
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="email@example.com"
              className="crm-basic__input"
            />
          </div>
        </div>

        <div className="crm-basic__group">
          <label className="crm-basic__label">
            <FaPhone className="crm-basic__label-icon" />
            Telefon
          </label>
          <div className="crm-basic__input-wrapper">
            <FaPhone className="crm-basic__input-icon" />
            <input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              placeholder="+45 12 34 56 78"
              className="crm-basic__input"
            />
          </div>
        </div>

        <div className="crm-basic__group">
          <label className="crm-basic__label">
            <FaLinkedin className="crm-basic__label-icon" />
            LinkedIn profil
          </label>
          <div className="crm-basic__input-wrapper">
            <FaLinkedin className="crm-basic__input-icon" />
            <input
              type="url"
              name="linkedinUrl"
              value={formData.linkedinUrl}
              onChange={handleChange}
              placeholder="https://linkedin.com/in/..."
              className="crm-basic__input"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default GrundlæggendeInfo;
